import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { AccountService } from 'src/app/tabms/services/admin/account/account.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { userPaySlips } from 'src/app/tabms/models/base/base';
import { ApiSessionService } from 'src/app/tabms/services/global/api-session.service';
import { TabUserPaySlipService } from 'src/app/tabms/services/admin/tab-user-pay-slip/tab-user-pay-slip.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { Subject, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';

@Component({
  selector: 'app-change-pay-slip',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './change-pay-slip.component.html',
  styleUrl: './change-pay-slip.component.scss'
})
export class ChangePaySlipComponent implements OnInit, OnDestroy {
  selectedPaySlip;
  paySlipsData: userPaySlips[] = []
  currentLang: string;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private sessionService: SessionWrapperService,
    private apiSession: ApiSessionService,
    private tabUserpaySlipService: TabUserPaySlipService,
    private baseService: BaseService,
    private themelayoutService: ThemeLayoutService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.themelayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
      }
    })

  }

  ngOnInit(): void {
    let session = this.sessionService.getsessionData();
    this.tabUserpaySlipService.GetPaySlipsByUser(session.userid).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.paySlipsData = res.result;
          let defaultPaySlip: userPaySlips = this.sessionService.getDefaultPaySlip();
          this.selectedPaySlip = defaultPaySlip.payslip.payslipcode;
        }
      },
      error: (err) => {
      }
    });
  }



  paySlipSelect(paySlip: number) {
    this.selectedPaySlip = paySlip;
    let paySlipObj = this.paySlipsData.find(x => x.payslip.payslipcode == paySlip);
    this.sessionService.setDefaultPaySlip(paySlipObj); //set on browser session
    this.apiSession.changeUserCurrentPaySlip(paySlip); //send to api session
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

